import axiosServices from './request';
/** AI创作 */
const RaysServe = axiosServices('/audiobook/v1.0');
// 测试用
// const RaysServe = axiosServices('/raysservespeaker/v1.0');

export default {
  /** 文案写作示例 */
  listExample: RaysServe('get', 'copywriting/listExample'),
  /** 文案风格模板列表 */
  listStyleName: RaysServe('get', 'copywriting/listStyleName'),
  /** 文案创作记录  */
  listPageCopywritingRecord: RaysServe('get', 'copywriting/listPageCopywritingRecord'),
  /** 速读稿件 */
  createTopicAndAbstract: RaysServe('post', 'readArticle/createTopicAndAbstract'),
  /** 查询速读稿件记录 */
  pageArticleReadRecordVOs: RaysServe('get', 'readArticle/pageArticleReadRecordVOs'),
  /** 生成图书描述（帮我写） */
  getBookDesc: RaysServe('post', 'copywriting/getBookDesc'),
  /** 创建文案 */
  createCopywriting: RaysServe('post', 'copywriting/createCopywriting'),
  /** 催开发 */
  addAiUserOperate: RaysServe('post', 'copywriting/addAiUserOperate'),
  /** 查询是否已操作 */
  getTodayUserOperate: RaysServe('post', 'copywriting/getTodayUserOperate'),
  /** AI创作记录 */
  pageAiWriteRecords: RaysServe('get', 'aiRecord/pageAiWriteRecords'),
  /** 查询记录详情 */
  getAiWriteRecord: RaysServe('get', 'aiRecord/getAiWriteRecord'),
  /** 稿件速读-上传文件 */
  createTopicAndAbstractByFile: RaysServe('post', 'readArticle/createTopicAndAbstractByFile'),
  /** 稿件速读-上传记录 */
  pageArticleUploadReadRecordVOs: RaysServe('get', 'readArticle/pageArticleUploadReadRecordVOs'),
  /** 删除上传记录 */
  delUploadHistory: RaysServe('post', 'readArticle/delUploadHistory'),
  /** 速读详情 */
  getArticleReadRecord: RaysServe('get', 'readArticle/getArticleReadRecord'),
  /** 图片比例列表 */
  listImageScale: RaysServe('get', 'aiImage/listImageScale'),
  /** 获取短语分类 */
  classifyPhrases: RaysServe('get', 'aiImage/classifyPhrases'),
  /** 生成图片 */
  generateImage: RaysServe('post', 'aiImage/generateImage'),
  /** 图片生成记录 */
  pageImageRecordVOs: RaysServe('get', 'aiImage/pageImageRecordVOs'),
  /** 查询图片生成记录详情 */
  queryImageRecordVO: RaysServe('get', 'aiImage/queryImageRecordVO'),
  /** 试听音频(同步)
   * @param {String} text ssml文本
   * @param {String} format 音频参数，目前固定为`audio-24khz-48kbitrate-mono-mp3`
   * @see https://learn.microsoft.com/zh-cn/azure/cognitive-services/speech-service/rest-text-to-speech?tabs=streaming#audio-outputs
   */
  trialAiAudio: RaysServe('post', 'aiAudio/trialAiAudio'),
  /** 试听长音频 */
  trialMoreAiAudio: RaysServe('post', 'aiAudio/trialMoreAiAudio'),
  /** 获取语言列表 */
  listLanguage: RaysServe('get', 'aiAudio/listLanguage'),
  /** 获取发音人列表 */
  listVoicer: RaysServe('post', 'aiAudio/listVoicer'),
  // 新的发音人接口
  listVoicerNew: RaysServe('post', 'yiListeningSpeaker/list'),
  /** 获取发音人列表 */
  listGatewayVoicer: RaysServe('post', 'aiAudio/listGatewayVoicer'),
  /** 保存发音人 */
  saveVoicerRecord: RaysServe('post', 'aiAudio/saveVoicerRecord'),
  /** 音频合成记录滚动加载分页 */
  listAiAudioRecord: RaysServe('get', 'aiAudio/listAiAudioRecord'),
  /** 批量删除合成记录 */
  deleteRecordByIds: RaysServe('post', 'aiAudio/deleteRecordByIds'),
  // 音频合成记录表格分页
  listPageAiAudioRecord: RaysServe('get', 'aiAudio/listPageAiAudioRecord'),
  /** 新增创作音频 */
  createAiAudio: RaysServe('post', 'aiAudio/createAiAudio'),
  /** 新增长音频创作音频 */
  createMoreAiAudio: RaysServe('post', 'aiAudio/createMoreAiAudio'),
  /** 根据id查音频合成记录 */
  getAiAudioRecordById: RaysServe('get', 'aiAudio/getAiAudioRecordById'),
  /** 批量更新发音人设置 */
  batchUpdateVoicerRecord: RaysServe('post', 'aiAudio/batchUpdateVoicerRecord'),
  /** 发音人置顶 */
  topVoicer: RaysServe('get', 'aiAudio/topVoicer'),
  /** 取消发音人置顶 */
  cancelTopVoicer: RaysServe('get', 'aiAudio/cancelTopVoicer'),
  /** 提示音列表 type资源类型:1-背景音乐,2-提示音 */
  listDefaultResource: RaysServe('get', 'aiAudio/listDefaultResource'),
  /**音效列表*/
  getMusicList: RaysServe('get', 'aiUserAudio/listMusic'),
  /** 新增自定义背景音 */
  addResource: RaysServe('post', 'aiAudio/addResource'),
  /** 删除自定义背景音 */
  deleteResourceById: RaysServe('get', 'aiAudio/deleteResourceById'),
  /** 获取发音人场景及发音人列表 */
  listSceneAndVoicer: RaysServe('get', 'aiAudio/listSceneAndVoicer'),
  /** 下载高清大图 */
  upsampleImage: RaysServe('post', 'aiImage/upsampleImage'),
  /** 文案改写记录 */
  listCopywritingRewrite: RaysServe('get', 'copywriting/listCopywritingRewrite'),
  /** 文案点赞/点踩 */
  likeOrDislike: RaysServe('post', 'copywriting/likeOrDislike'),
  /** 文案改写 */
  addRewrite: RaysServe('post', 'copywriting/addRewrite'),
  /** 改写失败，重新生成 */
  generateRewriteAgain: RaysServe('get', 'copywriting/generateRewriteAgain'),
  /** 获取发音场景 */
  listScene: RaysServe('get', 'aiAudio/listScene'),
  /** 获取发音场景 */
  listGatewayScene: RaysServe('get', 'aiAudio/listGatewayScene'),
  /** 批量下载 */
  batchDownload: RaysServe('post', 'aiAudio/batchDownload'),
  /** 收藏发音人列表 */
  listCollectVoicer: RaysServe('get', 'aiAudio/listCollectVoicer'),
  // 新收藏发音人列表
  listCollectVoicerNew: RaysServe('get', 'yiListeningSpeaker/favorList'),
  /** 发音人数量 */
  getVoicerCount: RaysServe('get', 'aiAudio/getVoicerCount'),
  /** 异步生成音频 */
  trialLongAiAudio: RaysServe('post', 'aiAudio/trialLongAiAudio'),
  /** 异步生成长音频 */
  trialMoreLongAiAudio: RaysServe('post', 'aiAudio/trialMoreLongAiAudio'),
  /** 异步获取生成音频 */
  getTrialRecordById: RaysServe('get', 'aiAudio/getTrialRecordById'),
  /** 小睿币付费规则 */
  listAiCostRule: RaysServe('get', 'aiRecord/listAiCostRule'),
  // 客户留言
  addAiCustomerMsg: RaysServe('post', 'aiRecord/addAiCustomerMsg'),
  // 获取复制的命名
  getCopyTitle: RaysServe('get', 'aiAudio/getCopyTitle'),
  // 获取默认命名
  getDefaultTitle: RaysServe('get', 'aiAudio/getDefaultTitle'),
  // 修改标题
  updateTitleById: RaysServe('get', 'aiAudio/updateTitleById'),
  // ai有声书解析中文
  identifyWord: RaysServe('post', 'yiListeningWord/identifyWord'),
  // pdf上传解析
  handlePdfUpload: RaysServe('post', 'yiListeningPdf/handlePdfUpload'),
  // word上传解析
  uploadWord: RaysServe('post', 'yiListeningPdf/uploadWord'),
  // 动态修改pdf每页信息
  setResourceUploadDetails: RaysServe('post', 'yiListeningPdf/batchUpdateYiListeningResourceUploadDetails'),
  // 图片识别文本
  getImgToTxt: RaysServe('get', 'yiListeningPdf/imgToTxt'),
  // 获取发音人对应的类型
  queryByVoicerId: RaysServe('get', 'aiAudio/queryByVoicerId'),
  // 获取发音人模板列表
  getYiListeningVoicerTemplateList: RaysServe('get', 'aiAudio/getYiListeningVoicerTemplateList'),
  //查询该作品最新的上传记录
  getAiAudioPdfData: RaysServe('get', 'yiListeningPdf/queryLatestUserResourceUploadByAiAudioRecordId'),
  //修改用户pdf上传记录
  updateAiAudioPdfData: RaysServe('post', 'yiListeningPdf/updateYiListeningUserResourceUpload'),
  // pdf上传解析text
  handlePdfTextUpload: RaysServe('post', 'yiListeningPdf/handlePdfTextUpload'),
  // 查询用户导入的word记录
  queryAiAudioRecordId: RaysServe('get', 'yiListeningPdf/queryAiAudioRecordId'),

  // 添加用户反馈
  addFeedback: RaysServe('post', 'aiAudio/addFeedback'),
  // 根据内容匹配角色(pdf-上传文件)
  getRoleByContent: RaysServe('post', 'aiAudio/getRoleByContent'),
  // 添加文本
  submitContent: RaysServe('post', 'yiListeningBookContentController/submitContent'),
  // 根据内容匹配角色(pdf-查询结果)
  getRoleContentByRequestId: RaysServe('get', 'aiAudio/getRoleContentByRequestId'),
  // 从AI平台获取解析的多角色或者听力文稿的内容结果
  fetchByRequestId: RaysServe('get', 'yiListeningBookContentController/fetchByRequestId'),
  // 根据内容匹配角色（英语word-上传文件）
  getListeningByContent: RaysServe('post', 'aiAudio/getListeningByContent'),
  // 根据内容匹配角色（英语word-查询结果）
  getListeningResult: RaysServe('get', 'aiAudio/getListeningResult'),
  // 保存多音字修正记录
  addPolyphoneRecord: RaysServe('post', 'aiAudio/addPolyphoneRecord'),
  // 获取模板列表
  getTemplateList: RaysServe('get', 'aiAudio/getTemplateList'),
  // 根据文件id获取文件内容
  getContentByFileid: RaysServe('get', 'aiAudio/getContentByFileid'),
  // 根据发音人id获取发音人信息
  getVoicerInfo: RaysServe('post', 'aiAudio/getVoicerInfo'),
  // 添加记录
  addTemplateRecord: RaysServe('get', 'aiAudio/addTemplateRecord'),
  // 更新用户上传word记录
  updateAudioResource: RaysServe('get', 'aiAudio/updateAudioResource'),
  // 批量ocr识别
  batchImgToTxt: RaysServe('get', 'yiListeningPdf/batchImgToTxt'),
  // 新增背景音效使用记录
  addUseRecord: RaysServe('post', 'aiUserAudio/addUseRecord'),
  /** 有声书获取音频文件类型*/
  getPbMusicProTypeList: RaysServe('get', 'aiUserAudio/getPbMusicProTypeList'),
  // 获取有声书模板类型
  getAudioTemplateList: RaysServe('get', 'yiListeningBookCategory/bookList'),
  // 获取发音人详情
  getSpeakerDetail: RaysServe('get', 'yiListeningSpeaker/detail'),
  // 首页获取发音人类型
  getNameList: RaysServe('get', 'yiListeningBookCategory/nameList'),
  // 首页发音人列表
  categoryList: RaysServe('get', 'yiListeningSpeaker/categoryList'),
  // 校验当前用户是否为新用户 新用户还剩余多少字
  judgeTrialAccount: RaysServe('get', 'yiListeningBookContentController/judgeTrialAccount'),
  // 检查文件名称是否重复
  checkTitleExists: RaysServe('get', 'aiAudio/checkTitleExists'),
  //正式出版社能合成字数
  agentInfo: RaysServe('get', 'yiListeningBookContentController/agentInfo'),
  // 获取词组列表
  aiWordsList: RaysServe('get', 'aiWords/listPage'),
  // 根据id删除词组
  aiWordsDeletes: RaysServe('post', 'aiWords/deletes'),
  // 根据词组名称删除词组
  aiWordsDeleteByWords: RaysServe('post', 'aiWords/deleteByWords'),
  // 编辑词组
  aiWordsEdit: RaysServe('post', 'aiWords/edit'),
  // 添加词组
  aiWordsAdd: RaysServe('post', 'aiWords/add'),
  // 批量添加词组
  aiWordsBatchAdd: RaysServe('post', 'aiWords/batchAdd'),
  // 导入词库
  aiWordsExport: RaysServe('post', 'aiWords/export'),
  // 解析Word
  submitWordParse: RaysServe('post', 'yiListeningPdf/submitWordParse'),
  // 获取word解析内容
  getWordContext: RaysServe('get', 'yiListeningPdf/getWordContext'),
  // 新建文件夹并添加资源
  addFolderAndResource: RaysServe('post', 'folder/addFolderAndResource'),
  // 根据单词获取国际音标
  generateSoundmark: RaysServe('get', 'aiAudio/generateSoundmark'),
  // 获取合成音频列表
  getCompositeAudioStandardList: RaysServe('get', 'aiAudio/getCompositeAudioStandardList'),
  // 获取默认发音人
  getDefaultSpeaker: RaysServe('get', 'aiAudio/getDefaultSpeaker'),
  // 格式化试听合成参数 -- 词组连续
  getFormatWordList: RaysServe('post', 'aiWords/getFormatWordList'),
  // 新增修改自定义模板
  addOrModifyCustomTemplate: RaysServe('post', 'yiListeningBookContentController/addOrModifyCustomTemplate'),
  // 删除自定义模板
  deleteCustomTemplate: RaysServe('post', 'yiListeningBookContentController/deleteCustomTemplate'),
  // 获取模板详情
  customTemplateDetail: RaysServe('get', 'yiListeningBookContentController/customTemplateDetail'),
  // 自定义模板-添加文本
  submitCustomTemplateContent: RaysServe('post', 'yiListeningBookContentController/submitCustomTemplateContent'),
  // 自定义-模版从AI平台获取解析的多角色或者听力文稿的内容结果
  fetchCustomTemplateParseResult: RaysServe('get', 'yiListeningBookContentController/fetchCustomTemplateParseResult')
};